import { SETSHOWMESSAGE_SUCCESS } from '../slices/showMessageSlice';
export const showMessageAction = (data) => async (dispatch) => {
    dispatch(SETSHOWMESSAGE_SUCCESS(data));
};
